import dynamic from 'next/dynamic'
import pageBuilderCanRender from './magento-pagebuilder/detectPageBuilder'
import htmlCanRender from './html/detectHtml'

const PageBuilder = dynamic(() => import('./magento-pagebuilder/pagebuilder'))
const Html = dynamic(() => import('./html/html'))

const richContentRenderers = [
	{ name: 'PageBuilder', Component: PageBuilder, canRender: pageBuilderCanRender },
	{ name: 'Html', Component: Html, canRender: htmlCanRender },
]

export default richContentRenderers
